package dev.alimmz.portfolio.presentation

import androidx.lifecycle.ViewModel
import dev.alimmz.portfolio.data.repository.FakePortfolioRepository
import dev.alimmz.portfolio.domain.model.Experience
import dev.alimmz.portfolio.domain.model.Profile
import dev.alimmz.portfolio.domain.model.Project
import dev.alimmz.portfolio.domain.model.Skill
import dev.alimmz.portfolio.domain.repository.PortfolioRepository
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow

data class PortfolioState(
    val profile: Profile? = null,
    val projects: List<Project> = emptyList(),
    val experiences: List<Experience> = emptyList(),
    val skills: List<Skill> = emptyList(),
    val isLoading: Boolean = false,
)

class PortfolioViewModel(
    private val repository: PortfolioRepository = FakePortfolioRepository()
) : ViewModel() {

    private val _state = MutableStateFlow(PortfolioState())
    val state: StateFlow<PortfolioState> = _state.asStateFlow()

    init {
        loadData()
    }

    private fun loadData() {
        _state.value = PortfolioState(
            profile = repository.getProfile(),
            projects = repository.getProjects(),
            experiences = repository.getExperiences(),
            skills = repository.getSkills(),
            isLoading = false
        )
    }
}
